import { Language } from '../../../enums/const-enums';

export interface RassTinwebTranslations {
  instructions: {
    sign: string;
  };
}

const nlTranslations: RassTinwebTranslations = {
  instructions: {
    sign: 'Onderteken met je toegangscode',
  },
};

const enTranslations: RassTinwebTranslations = {
  instructions: {
    sign: 'Sign with your access code',
  },
};

export const rassTinwebTranslations = {
  [Language.NL]: nlTranslations,
  [Language.EN]: enTranslations,
  [Language.ES]: enTranslations,
  [Language.PT]: enTranslations,
};
